let ClientService = function (Restangular) {
  const Service = Restangular.all('admin/user_profile');

  let count = (query) => {
    query = query || {};
    query.type = 'CLIENT';
    query.deleted_at = 'null';
    return Service.customGET('count', query);
  }

  let save = (resource) => {
    if (resource.save) {
        return resource.save();
    } else {
        return Service.post(resource);
    }
  }

  let index = (query) => {
    query = query || {};
    query.type = 'CLIENT';
    query.deleted_at = 'null';
    return Service.getList(query);
  }

  let loadCharts = (params) => {
    return Service.customGET('report', params);
  }

  let getReportData = (params) => {
    return Service.customGET('report-data', params);
  }

  let load = (query) => {
    query = query || {};
    query.type = 'CLIENT';
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
        count(query)
        .then(response => {
            let count = response[0];
            index(query)
            .then(data => {
                resolve({count, data});
            })
            .catch(err => {
                reject(err);
            });
        })
        .catch(err => {
            reject(err);
        });
    });
  }

  let show = (id) => {
    return Service.get(id);
  }

  let destroy = (resource) => {
    resource.deleted_at = moment();
    return resource.save();
  }

  let downloadReport = () => {
    return Restangular.one('user_profile/full_report').get()
  }

  let downloadReportSmall = () => {
    return Restangular.one('user_profile/partial_report').get()
  }

  return { index, load, save, show, destroy, downloadReport, downloadReportSmall, loadCharts, getReportData } ;
};

ClientService.$inject = ['Restangular'];

export default ClientService;



// WEBPACK FOOTER //
// ./client/app/components/client/client.service.js